import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import VueRouter from 'vue-router'

Vue.use(VueRouter)

import Home from './components/Home.vue';
import Recommendations from './components/Recommendations.vue';

const router = new VueRouter({
	mode: 'history',
	routes: [
		{
			path: '/',
			component: Home
		},

		{
			path: '/recommendations',
			component: Recommendations
		},
	]

})

Vue.config.productionTip = false


new Vue({
	router,
	vuetify,
	render: h => h(App)
}).$mount('#app')
